import { render, staticRenderFns } from "./CourseDetailsView.vue?vue&type=template&id=33b85ac1&"
import script from "./CourseDetailsView.vue?vue&type=script&lang=ts&"
export * from "./CourseDetailsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports